/** OpenLayers vector feature id — String/Module numeric id collision 방지 */

export function toPanelMapStringFeatureId(stringId) {
  if (stringId == null || stringId === '') {
    return null;
  }
  const id = String(stringId);
  return id.startsWith('string_') ? id : `string_${id}`;
}

export function toPanelMapModuleFeatureId(moduleId) {
  if (moduleId == null || moduleId === '') {
    return null;
  }
  const id = String(moduleId);
  return id.startsWith('module_') ? id : `module_${id}`;
}

export function isPanelMapModuleFeatureType(featureType) {
  return featureType === 'Module' || featureType === 'module';
}

export function toPanelMapFeatureId(id, featureType, { solarModuleId } = {}) {
  if (isPanelMapModuleFeatureType(featureType) || solarModuleId != null) {
    return toPanelMapModuleFeatureId(id);
  }
  if (featureType === 'String' || featureType === 'string') {
    return toPanelMapStringFeatureId(id);
  }
  return id != null ? String(id) : null;
}
